export default "__VITE_ASSET__99dc5fcc__"